import * as actionType from "../ActionTypes";
import api from "../../config/api";

const state = {
  card_payment: 1,
  banking_payment: 2,
  bill_payment: 3,
  paypal_payment: 4,
  coin_payment: 5,
  true_money: 6,
  prompt_pay: 7
};
const getters = {
};
const actions = {
  [actionType.MAKE_PAYMENT_FOR_COIN_PACKAGE]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post(`/user-payments/`, data).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.FETCH_USER_PAYMENT]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.get(`/user-payments/${data.id}`).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.FETCH_USER_PAYMENTS]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post(`/user-payments/search?page=${data.page}`, data).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },

  [actionType.FETCH_ADVANCED_USER_PAYMENTS]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post(`/admin/user-payments/search?page=${data.page}`, data).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.FETCH_ADVANCED_USER_PAYMENTS_DETAILS]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.get(`/admin/user-payments/${data.id}`).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.UPDATE_USER_PAYMENT]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.put(`/user-payments/${data.id}`,
        {
          payment_method: data.payment_method,
          packages: data.packages,
          discount_code: data.discount_code,
          remove_discount: data.remove_discount,
          general_packages: data.general_packages
        }).then(result => {
          resolve(result.data);
        })
        .catch(error => reject(error));
    });
  },
  [actionType.PAYPAL]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post(`/user-payments/paypal`, {
        user_payment_id: data.id,
      }).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.PAY]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post(`/user-payments/pay`, data).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.FETCH_INVOICE_ADDRESS]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.get(`/user/invoices/address`, data).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.UPDATE_INVOICE_ADDRESS]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.put(`/user/invoices/address`, data).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.SEND_INVOICE]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post(`/user-payments/${data.id}/invoice`, {
        address: data.address,
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name,
        company_name: data.company_name,
        taxid: data.taxid
      }).then(result => {
        resolve(result.data);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GENERATE_INVOICE]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.get(`/user-payments/${data.id}/invoice`, {
        responseType: 'blob',
        headers: { 'Accept': 'application/pdf' },
      }).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.SEND_INVOICE_OR_MESSAGE_TO_USER]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post(`/admin/user-payments/${data.id}/notify`, {
        email: data.email,
        message: data.message
      }).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },

  [actionType.GET_PREBOOKING_DATES]: function ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post('/user-payments/affiliate/prebook', {
          package_detail_id: data.packDetailsId,
          listing_id: data.packId
        }).then(result => {
          resolve(result.data.data);
        })
        .catch(error => reject(error));
    });
  },
};

const mutations = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}